import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { TransactionListStoppedAtCell } from '@app/feature/transaction/transaction-list/transaction-list-stopped-at.cell';
import { TransactionListStoppedAtHeader } from '@app/feature/transaction/transaction-list/transaction-list-stopped-at.header';

export const ChargePointChannelTransactionListStoppedAtColumn: IdentifiedColumnDef<
  TransactionModel,
  TransactionModel['stoppedAt']
> = {
  enableSorting: false,
  header: TransactionListStoppedAtHeader,
  cell: TransactionListStoppedAtCell,
};
